import {LUX_INPUT_TYPE, LUX_TEMPLATE_TYPE} from '@lux/wardrobe-lib'

export const columns = [
    {
        field: 'surveyName',
        header:  'modals.new.activity.section.action.survey.table.name',
        filterType: LUX_INPUT_TYPE.text,
    },
    {
        field: 'surveyType',
        header: 'modals.new.activity.section.action.survey.table.type',
        sortable: true,
        filterType: LUX_INPUT_TYPE.text,
    },
    {
        field: '',
        template: LUX_TEMPLATE_TYPE.actions
    }
]